// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"82":"f780d7747500b8bca1d9","422":"81c4ce4c2f7fc474274b","836":"fed4356ac41044800e75","932":"b73803fd538a06e68caa","959":"29236f52a477150af98a"}[chunkId] + ".js";
};